import { config } from '../../config';
import { prepareHeaders } from '../../configuration/tokenHandling/prepareHeaders';

import type { LoaderFunctionArgs } from "react-router";
import { ExtractData } from "./types/types";
import { intToMonth } from '../../shared/utils/formatters';


async function extractLoaderFinancialHealth({ request }: LoaderFunctionArgs) {

  const url = new URL(request.url);
  const assetId = url.searchParams.get("asset_id");
  const month = url.searchParams.get("month");
  const year = url.searchParams.get("year");

  if (!month || !year || !assetId) {
    return null;
  }

  const headers = await prepareHeaders(new Headers());
  const apiUrl = config.backend.SCORES_SERVICE + `/v2/relationships/${assetId}/financial-health/${year}/${month}`
  const response = await fetch(apiUrl, {method: "GET", headers});
  const data: ExtractData = await response.json();
  return {response: data, date: `${intToMonth(Number(month))}/${year}`};
}

export { extractLoaderFinancialHealth };